import { render, staticRenderFns } from "./RegionReminderDialog.vue?vue&type=template&id=4d96236b&scoped=true"
import script from "./RegionReminderDialog.vue?vue&type=script&lang=js"
export * from "./RegionReminderDialog.vue?vue&type=script&lang=js"
import style0 from "./RegionReminderDialog.vue?vue&type=style&index=0&id=4d96236b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d96236b",
  null
  
)

export default component.exports